interface SpacerProps {
  height?: string;
}

export const Spacer: React.FC<SpacerProps> = (props: SpacerProps) => {
  const { height } = props;
  return <div style={{ height: height ?? '2vh' }}></div>;
};
